import { useQuery } from '@tanstack/react-query';
import {
  getSystemHealth,
  getSystemInstant,
  getRiskState,
  getSystemResources,
} from '../services/api';

/**
 * Santé système — polling indépendant par carte.
 * Une query en erreur n'effondre pas les autres (dégradation par carte).
 * refetchInterval ~3000ms, aligné sur le cockpit.
 */
export function useSanteData() {
  const health = useQuery({
    queryKey: ['sante', 'health'],
    queryFn: getSystemHealth,
    refetchInterval: 3000,
  });
  const instant = useQuery({
    queryKey: ['sante', 'instant'],
    queryFn: getSystemInstant,
    refetchInterval: 3000,
  });
  const risk = useQuery({
    queryKey: ['sante', 'risk'],
    queryFn: getRiskState,
    refetchInterval: 3000,
  });
  const resources = useQuery({
    queryKey: ['sante', 'resources'],
    queryFn: getSystemResources,
    refetchInterval: 8000,
  });

  return { health, instant, risk, resources };
}
